<template>
  <div>
    <div class="d-none d-md-block pa-4 pa-md-2">
      <Breadcrumbs
        headline="Cơ sở vật chất"
        :link="[{ text: 'Cơ sở vật chất', href: '../facilities' }]"
      />
    </div>

    <v-card class="pa-2 mx-md-2">
      <v-row no-gutters>
        <v-col cols="12" md="4" class="text-center">
          <h2>{{ facility.name }}</h2>
          <facility-picker :facility="facility"></facility-picker>
        </v-col>

        <v-col cols="12" md="6" class="px-2">
          <h3 class="mb-4">Thông tin CSVC</h3>
          <facility-new-form v-if="facility" :facility="facility" ref="infoForm" />
        </v-col>

        <v-col
          cols="12"
          md="2"
          class="text-right"
          v-if="['super_admin', 'education_manager'].includes(role.type)"
        >
          <v-btn color="primary" class="mr-2" depressed medium @click.stop="save">Lưu</v-btn>
          <v-btn :to="'/facilities'" depressed medium>Hủy</v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import FacilityNewForm from '@/components/basic/form/FacilityForm.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import FacilityPicker from '@/components/basic/picker/FacilityPicker'

export default {
  components: { FacilityNewForm, Breadcrumbs, FacilityPicker },
  data() {
    return {
      loading: false,
      currentId: null
    }
  },
  computed: {
    ...mapGetters('facility', ['facility', 'imgs']),
    ...mapState('constant', ['facilityStatus', 'facilityTypes']),
    ...mapGetters('app', ['department']),
    ...mapState('auth', ['profile', 'role']),
    allFacilityStatus() {
      return this.facilityStatus.reduce(
        (data, curent) => ({
          ...data,
          [curent.status]: curent['title']
        }),
        {}
      )
    },
    allFacilityType() {
      return this.facilityTypes.reduce(
        (data, curent) => ({
          ...data,
          [curent.status]: curent['title']
        }),
        {}
      )
    }
  },
  methods: {
    ...mapActions('facility', ['fetchFacility', 'updateFacility', 'destroyImage']),
    async save() {
      const info = this.$refs.infoForm.getData()
      await this.updateFacility({
        id: this.facility.id,
        ...info
      })
    },
    removeImage() {
      if (this.currentId) this.destroyImage(this.currentId)
    }
  },
  async created() {
    this.loading = true
    await this.fetchFacility(this.$route.params.id)
    this.loading = false
  }
}
</script>
<style scoped>
.border {
  border: solid 1px lightgray;
}
</style>
